var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopyLink = function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.07,
    width: 20,
    height: 20,
    rx: 6,
    fill: "#091637"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#copyLink_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.263 6.015a2.296 2.296 0 1 0-3.248 3.248l.945.944a.375.375 0 1 1-.53.53l-.945-.944a3.046 3.046 0 0 1 4.308-4.308l.944.944a.375.375 0 1 1-.53.53l-.944-.944Zm3.777 3.248a.375.375 0 0 1 .53 0l.945.944a3.046 3.046 0 0 1-4.308 4.308l-.944-.944a.375.375 0 1 1 .53-.53l.944.944a2.296 2.296 0 1 0 3.248-3.248l-.945-.944a.375.375 0 0 1 0-.53ZM7.846 7.846a.375.375 0 0 1 .53 0l3.778 3.778a.375.375 0 0 1-.53.53L7.846 8.376a.375.375 0 0 1 0-.53Z",
    fill: "#091637"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copyLink_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h12v12H0z"
  })))));
};

export default SvgCopyLink;